import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import EquipmentAlertViewMonitoringPage from 'components/inner/EquipmentAlertViewMonitoringPage';
import { getEquipmentAlertsById } from 'components/axios/equipmentAlertsAxios';
import { useQuery } from '@tanstack/react-query';
import Error404 from 'pages/Error404';


const EquipmentAlertViewMonitoring = () => {
    const {id} = useParams();

    const [notFound, setNotFound] = useState(false);
        
    useEffect(() => {
        setNotFound(false);
    }, [id]);

    const { 
        data : info, 
    } = useQuery({
        queryKey: ['equipment-iot-view-base', id],

        queryFn: () => getEquipmentAlertsById(id),

        // 깜빡임 방지
        placeholderData: previousData => previousData,

        refetchOnWindowFocus: false,
        refetchOnReconnect: false,

        enabled: !!id,
        retry: false,
        onError: (error) => {
            if (error?.response?.status === 404) {
                setNotFound(true);
            }
        }
    });
    
    if (notFound) {
        return <Error404 />
    }
    
    return (
        <EquipmentAlertViewMonitoringPage alertId={id} />
    )
}

export default EquipmentAlertViewMonitoring;